import '../plugins/AnchorsPlugin.js';

// initialize smooth anchor links
export default function initAnchors() {
	new SmoothScroll({
		anchorLinks: '.anchor-link',
		extraOffset: 0,
		activeClasses: 'parent',
		anchorActiveClass: 'active',
		wheelBehavior: 'none',
		animDuration: 0,
	});
}
